import {useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/methods/cashapp_p2p_deposit/stage';
import {agreeNotice, setStage} from '../../../../../reducers/wallet/actions/cashapp_p2p_deposit';
import {setPreset} from '../../../../../reducers/wallet/actions';
import {NumericFormat} from 'react-number-format';
import FormInput from '../../../../components/form-input';
import BlueButton from '../../../../components/blue-button';
import ModalsLib from '../../../../../lib/modals';

export default () => {
    const {props} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <>
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title"></div>
                    <div className="descriptions"></div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div> 
            <div className="modal-body">
                <div className="notice-title">Please note!</div>
                <div className="notice-description">
                    It is very important that you send the exact amount and indicate the payment note.
                </div>

                <div className="notice-cashapp">
                    <div className="notice-cashapp-blocks">
                        <div className="notice-block">
                            <div className="notice-block-title">Amount</div>
                            <div className="notice-block-value">${props.order.receiver.amount}</div>
                        </div>
                        <div className="notice-block">
                            <div className="notice-block-title">Note</div>
                            <div className="notice-block-value">{props.order.receiver.note}</div>
                        </div>
                    </div>
                    
                    <svg width="19" height="9" viewBox="0 0 19 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.4201 0.949951L10.9001 7.46995C10.1301 8.23995 8.87008 8.23995 8.10008 7.46995L1.58008 0.949951" stroke="#4F546A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <div className="notice-image">
                        <div className="notice-image-block">
                            For <span>{props.order.receiver.note}</span>
                        </div>
                    </div>
                </div>

                <div class="modal-message warning">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <span>If you provide incorrect information, you will be able to receive your deposit within <b>48 hours</b> with the help of support.</span>
                </div>
            </div>
            <div className="modal-footer">
                <BlueButton onClick={e => {
                    dispatch(agreeNotice()); 
                }}>
                    I'm agree
                </BlueButton>
                <div className="button back" onClick={e => dispatch(setStage('create'))}>
                    Back
                </div> 
            </div>
        </>
    )
}